import {LoginAlertConstant} from "../redux_constants/login.alert.constant";
import {authenticationStatus} from "../utils/const";
import {notNull} from "../utils/utils";

const InitialState = {
    status: false,
    auth: null,
    isFetching: false,
    loginStatus: false,
    csrfToken: null,
    user_id: null,
    username: null,
    usernameTotp: null,
    passwordTotp: null,
    isTotpEnabled: false,
    deployment_mode: 'cloud',
    isWrongCredential: false,
    loginFailureMessage: '',
    isForbidden: false,
    isLockedOut: false,
    isServerUnreachable: false,
    superuser: false,
    firstName: '',
    isSameUserLoggedInStatus: false,
    authVerificationStatus: authenticationStatus.PENDING
}

export const loginAlerts = ( state = InitialState , action) => {
    switch(action.type){
        case LoginAlertConstant.CHANGE_AUTH_STATUS :
            return {
                ...state,
                authVerificationStatus: action.response,
            }
        case LoginAlertConstant.LOGIN_REQUEST :
            return{
                ...state,
                isFetching : true
            }
        case LoginAlertConstant.LOGIN_SUCCESS :
            return {
                ...state,
                isFetching : false,
                loginStatus : true,
                authToken : action.response.data.token,
                status : true,
                username : action.response.data.user.first_name,
                user_id : action.response.data.user.id,
                superuser : action.response.data.user.is_superuser,
                deployment_mode: action.response.data.deployment_mode,
                isWrongCredential : false,
                isServerUnreachable : false,
                authVerificationStatus: authenticationStatus.AUTHENTICATED,
                loginFailureMessage: ''
            }
        case LoginAlertConstant.CLEAR_LOGIN_FAILURE_MESSAGE :
            return {
                ...state,
                loginFailureMessage: '',
                isFetching : false,
                authVerificationStatus: authenticationStatus.UNAUTHENTICATED,
            }
        case LoginAlertConstant.SET_IS_TOTP_ENABLED :
            return {
                ...state,
                isTotpEnabled: action.isTotpEnabled,
            }
        case LoginAlertConstant.LOGIN_ERROR :
            const error_list = action.response?.data?.non_field_errors
            const loginFailureMessage = notNull(error_list) && error_list.length > 0 ? error_list[0] : ''
            return {
                ...state,
                // HTTP 502 Bad Gateway or HTTP 504 Gateway Timeout
                isServerUnreachable : action.response.status === 502 || action.response.status === 504,
                // HTTP 403 Forbidden
                isForbidden: action.response.status === 403,
                // User has been locked out for some reason
                isLockedOut: action.response.status === 403 && action.response.data && action.response.data.code === "locked_out",
                // User entered wrong credentials
                // TODO: check isn't properly done
                isWrongCredential : !(action.response.status === 504 || action.response.status === 403)
                    && action.response.status === 400,
                loginFailureMessage: loginFailureMessage,
                isFetching : false,
                authVerificationStatus: authenticationStatus.UNAUTHENTICATED,
            }
        case LoginAlertConstant.LOGOUT :
            return {
                ...state,
                auth : null,
                isFetching : false,
                loginStatus : false,
                csrfToken : null,
                authToken : null,
                status : false,
                isWrongCredential : false,
                isServerUnreachable : false,
                authVerificationStatus: authenticationStatus.UNAUTHENTICATED,
            }
        case LoginAlertConstant.CSRF_TOKEN_SUCCESS :
            return {
                ...state,
                csrfToken: action.response,
            }
        case LoginAlertConstant.PROXY_LOGIN_SUCCESS :
            return {
                ...state,
                proxyLogin: action.response,
            }
        case LoginAlertConstant.USER_CREDENTIALS:
            return {
                ...state,
                usernameTotp: action.usernameTotp,
                passwordTotp: action.passwordTotp,
                isFetching: action.isFetching,
            }
        case LoginAlertConstant.UPDATE_FIRSTNAME:
            return {
                ...state,
                firstName: action.firstName
            }
        case LoginAlertConstant.UPDATE_SAME_USER_LOGGED_IN_STATUS:
            return {
                ...state,
                isSameUserLoggedInStatus: action.isSameUserLoggedInStatus
            }
        default :
            return state
    }
}